import { action as actionCreator } from "typesafe-actions";
import { asyncFailed, asyncHasFinished, asyncIsRunning, asyncNotStarted } from "@advosys/component-react-utils";
export var PreviewDialogActionTypes;
(function (PreviewDialogActionTypes) {
    PreviewDialogActionTypes["GetPreviewRequest"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:preview-dialog:preview-dialog-store:GetPreviewRequest";
    PreviewDialogActionTypes["GetPreviewSuccess"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:preview-dialog:preview-dialog-store:GetPreviewSuccess";
    PreviewDialogActionTypes["GetPreviewFail"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:preview-dialog:preview-dialog-store:GetPreviewFail";
    PreviewDialogActionTypes["ClearPreviewDialog"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:preview-dialog:preview-dialog-store:ClearPreviewDialog";
})(PreviewDialogActionTypes || (PreviewDialogActionTypes = {}));
export const actions = {
    getPreviewRequest: (preparedInvoiceId) => actionCreator(PreviewDialogActionTypes.GetPreviewRequest, { preparedInvoiceId }),
    getPreviewSuccess: (base64) => actionCreator(PreviewDialogActionTypes.GetPreviewSuccess, { base64 }),
    getPreviewFail: (errorMessage) => actionCreator(PreviewDialogActionTypes.GetPreviewFail, { error: errorMessage }),
    clearPreviewDialog: () => actionCreator(PreviewDialogActionTypes.ClearPreviewDialog)
};
const initialState = {
    loading: asyncNotStarted
};
export const previewDialogReducer = (state = initialState, action) => {
    switch (action.type) {
        case PreviewDialogActionTypes.GetPreviewRequest:
            return { ...state, loading: asyncIsRunning };
        case PreviewDialogActionTypes.GetPreviewSuccess:
            return { ...state, loading: asyncHasFinished(action.payload) };
        case PreviewDialogActionTypes.GetPreviewFail:
            return { ...state, loading: asyncFailed(action.payload.error) };
        case PreviewDialogActionTypes.ClearPreviewDialog:
            return initialState;
        default:
            return state;
    }
};
